import React from 'react';
import "./Learn.css";
import about from "../images/about.png";


const Learn = () => {
    return (




        <div className="main">
            <h1>Mother Nature Is Calling For You</h1>
            <h2>Explore Various Learn Modules</h2>
            <div className="L2">
                <div className="L5">
                    <div className="L7">
                        <img src={about} alt='abt' />
                    </div>
                    <div className="L8">
                        <img src={about} alt='abt' />
                    </div>
                </div>

                <div className="L6">
                    <div className="L9">
                        <img src={about} alt='abt' />
                    </div>
                    <div className="L10">
                        <img src={about} alt='abt' />
                    </div>
                </div>

                <div className="L13">
                <div className="L15">
                    <img src={about} alt='abt' />
                </div>
                <div className="L16">
                    <img src={about} alt='abt' />
                </div>
            </div>

            <div className="L14">
            <div className="L17">
                <img src={about} alt='abt' />
            </div>
            <div className="L18">
                <img src={about} alt='abt' />
            </div>
        </div>



            </div>

        </div>


    );
};

export default Learn;